(function () {
  class WinlineBatcherAllAtOnceThenIndividual {
    constructor() {}

    isCellDuplicate(cells, cell) {
      for (let i = 0; i < cells.length; ++i) {
        if (cells[i].cell.reel === cell.reel && cells[i].cell.row === cell.row)
          return true;
      }
      return false;
    }

    batch(wins, celebrationThreshold) {
      let allAtOnce = [];
      let individual = [];
      let isGreaterThanThreshold =
        wins.totalLineWinnings > celebrationThreshold;

      for (let i = 0; i < wins.winningLines.length; ++i) {
        let win = wins.winningLines[i];

        let individualLine = [];
        for (let j = 0; j < win.positions.length; ++j) {
          let winData = {
            cell: win.positions[j],
            symbolId: win.symbol.ids[j],
            winId: win.symbol.value,
            celebrate: isGreaterThanThreshold,
            winline: i,
          };

          individualLine.push(winData);
          if (!this.isCellDuplicate(allAtOnce, win.positions[j])) {
            allAtOnce.push(winData);
          }
        }

        if (wins.winningLines.length > 1)
          // no need to show individual if all at once shows only winline
          individual.push(individualLine);
      }

      return [].concat([allAtOnce], individual);
    }
  }

  let create = function () {
    return new WinlineBatcherAllAtOnceThenIndividual();
  };
  resourceManager.registerSharedPlugin(
    "winlineBatcherAllAtOnceThenIndividualEx",
    create
  );
})();
